export const iconFontAwesomeHumanitarianUserInjured = (
	<i className="fa-solid fa-user-injured"></i>
);
